import { map, flow, orderBy } from 'lodash/fp';
import moment from 'moment';
import React from 'react';
import {
    SignalsTemplateTable,
    TR,
    Header as SignalsHeader,
    SignalsPage,
    TD,
    VSpace,
    Text,
    useSignalsData,
    getCompositeRiskCell,
    getPulseCell,
    getHighLowCell,
    getRiskBandCell,
    getCountryCell,
    getRiskCell,
    Footer,
    Table as HtmlTable,
    TBody,
    LogoImage,
} from './SignalsTemplateComponents';

const COLS = [
    { text: 'Country', width: '17%' }, // Needs 14% Minimum
    { text: 'Risk', width: '22%' }, // Needs 22% Minimum
    { text: 'Pulse (Value)', width: '15%' }, // Needs 12% Minimum
    { text: 'Composite (Change)', width: '17%' }, // Needs 17% Minimum
    { text: 'New High/Low', width: '13%', fontSize: '8px' }, // Needs 15% Minimum
    { text: 'Risk Band', width: '16%' }, // Needs 15% Minimum
];

const Table = React.memo(({ data }: { data: any }) => {
    const rows = flow(
        orderBy(['country', 'risk'], ['asc', 'asc']),
        map((row: any) => {
            return [
                getCountryCell(row),
                getRiskCell(row),
                getPulseCell(row),
                getCompositeRiskCell(row),
                getHighLowCell(row),
                getRiskBandCell(row),
            ];
        })
    )(data);

    return (
        <TR>
            <TD>
                <SignalsTemplateTable columns={COLS} rows={rows} />
            </TD>
        </TR>
    );
});

const Header = React.memo(
    ({ reportDate, timeWindow }: { reportDate: Date; timeWindow: string }) => {
        return (
            <React.Fragment>
                <TR>
                    <TD>
                        <SignalsHeader>DAILY SIGNALS</SignalsHeader>
                    </TD>
                </TR>
                <TR>
                    <TD align="center">
                        <Text bold>
                            Signals Observed on{' '}
                            {moment(reportDate).format('DD MMM YYYY')}, over{' '}
                            {timeWindow} period
                        </Text>
                    </TD>
                </TR>
                <VSpace />
                <TR>
                    <TD style={{ padding: '0 12px' }}>
                        <HtmlTable>
                            <TBody>
                                <TR>
                                    <TD
                                        style={{
                                            paddingBottom: 8,
                                        }}>
                                        <LogoImage />
                                    </TD>
                                    <TD
                                        align="left"
                                        style={{ paddingLeft: 16 }}>
                                        <Text bold>BMI Geo Risk Signals</Text>{' '}
                                        <Text>
                                            alert clients to significant
                                            movements in our daily risk
                                            indicators
                                        </Text>
                                    </TD>
                                </TR>
                            </TBody>
                        </HtmlTable>
                    </TD>
                </TR>
            </React.Fragment>
        );
    }
);

const SignalsTemplateDaily = React.memo(() => {
    const { signals, reportDate, timeWindow, uid } = useSignalsData();

    return (
        <SignalsPage>
            <Header reportDate={reportDate} timeWindow={timeWindow} />
            <VSpace />
            <Table data={signals} />
            <VSpace />
            <Footer uid={uid}/>
        </SignalsPage>
    );
});

export default SignalsTemplateDaily;
